import { adminAndPublicRelationPolicy} from './admin-and-public-relation'
const policyNamespace = 'news'

const policyMap = new Map()
policyMap.set(`${policyNamespace}/view`, adminAndPublicRelationPolicy)
policyMap.set(`${policyNamespace}/view-any`, adminAndPublicRelationPolicy)
policyMap.set(`${policyNamespace}/create`, adminAndPublicRelationPolicy)
policyMap.set(`${policyNamespace}/edit`, adminAndPublicRelationPolicy)
policyMap.set(`${policyNamespace}/delete`, adminAndPublicRelationPolicy)

export default policyMap
